// extracted by mini-css-extract-plugin
module.exports = {"info":"info-1aWQ3","segments":"segments-yew25","footer":"footer-3zhpx","button_default":"button_default-3-Ok1","button":"button-3oF0R"};